import {
  borderWidth,
  colors,
  radius,
  shadows,
  sizes,
  spacings,
} from "../../../assets/themes";
import { Block, Skeleton } from "../../../components";

const JobsSkeleton = () => (
  <Skeleton.Group>
    {new Array(3).fill("").map((_, i) => (
      <Block
        key={`job-skel-${i}`}
        marginY={spacings.m}
        borderRadius={{ xs: radius.ml, md: radius.l }}
        boxShadow={shadows.xs}
        border={`solid ${borderWidth.s} ${colors.border}`}
        padding={spacings.s}
        backgroundColor={colors.background}
        display="flex"
        alignItems="center"
        gap={spacings.m}
      >
        <Skeleton
          width={{ xs: "112px", md: "220px" }}
          css={`
            aspect-ratio: 1/1;
          `}
        />
        <Block spaceY={spacings.m} flex="1">
          <Skeleton
            height={{ xs: sizes.size16, md: sizes.size24 }}
            width="80%"
          />
          <Skeleton
            height={{ xs: sizes.size14, md: sizes.size16 }}
            width="50%"
          />
        </Block>
      </Block>
    ))}
  </Skeleton.Group>
);

export default JobsSkeleton;
